import { useSelector } from 'react-redux';
import slidewords from './slideDictionary';
import Pills from '../pills/Pills.js';
import { languageSwitch } from '../../dictionary/translateFunctions';
import Icon from '../icon/icon.js';
import './slide.css';
import Devider from '../devider/Devider.js'

const Slide = () =>{
    const lang = useSelector((state) => state.lang.lang);
    const dictionary = slidewords;
    const screen = window.screen.width;
    const contactInfo = dictionary.sldcon[lang];
    const colors = {
            white:'rgba(255, 255, 255, 1)',
            gray:'rgba(192, 192, 192, 1)',
            violet:'rgba(119, 54, 215, 1)',
            calipso:'rgba(52, 149, 215, 1)',
            carbon:'rgba(51, 51, 51, 1)'
        };

    return(
        <div className='heroBanner' style={{backgroundImage:'url(./assets/galeria/yo.png)'}}>
            <div className='heroBanner-contact'>
                <div className='heroBanner-contact-main'>
                    {contactInfo.map((info,index)=>(
                        <>
                            <div className='heroBanner-contact-elemento'>
                            <Icon source={info[0]} color={colors.gray}></Icon> 
                            {index === 0?<p className='heroBanner-contact-texto'><a href='https://www.linkedin.com/in/david-muñoz-trollund-3bb111a' target='_blank'>{info[1]}</a></p>:<p className='heroBanner-contact-texto'>{info[1]}</p>} 
                            </div>
                            {index === contactInfo.length - 1 ? '':<Devider direction={'vertical'}></Devider>}
                        </>    
                    ))}
                </div>
            </div>
            <div className='heroBanner--personal'>
                {screen > 500 ? <h1 className='heroBanner--personal--name'>David Muñoz Trollund</h1>:<h2 className='heroBanner--personal--name'>David Muñoz Trollund</h2>}
                <div className='heroBanner--personal--rol'>
                    <Pills type={'filled'} color={'violet'} text={dictionary.sldc[lang].c1} icon={'none'}></Pills>
                    <Pills type={'filled'} color={'violet'} text={dictionary.sldc[lang].c2} icon={'none'}></Pills>
                </div>
            </div>
            <div className='heroBanner--presentation'>
                <p className='heroBanner--presentation--text'>{languageSwitch(dictionary.sldd, lang)}</p>
                <div className='heroBanner--presentation--pills'>
                    {
                        dictionary.slds[lang].map((skill) => (
                        <Pills key={skill} type={'outlined'} color={'white'} text={skill} icon={'check_circle'}></Pills>))
                    }
                </div>
            </div>
        </div>
    )
}

export default Slide;